import React from 'react';
import PropTypes from 'prop-types';

import MusterDepot
  from '../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/MusterDepot/MusterDepot';
import FavoriteListSelection
  from '../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/FavoriteListSelection/FavoriteListSelection';
import ModelPortfolioSelection
  from '../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/ModelPortfolioSelection/ModelPortfolioSelection';
import InvestmentStrategySelection
  from '../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/InvestmentStrategySelection/InvestmentStrategySelection';

import InstrumentSelectionFlow from './containers/InstrumentSelectionFlow';
import PortfolioSelectionFlow from './containers/PortfolioSelectionFlow';
import SelfManagedSelectionFlow from './containers/SelfManagedSelectionFlow';
import CustomerDepotSelection from "../CustomerDepotSelection/CustomerDepotSelection";

const SOURCE_CATEGORY = {
  INSTRUMENT: 'INSTRUMENT',
  PORTFOLIO: 'PORTFOLIO',
  SELF_MANAGED: 'SELF_MANAGED',
};

/**
 * Single source of truth describing every selectable source: which component
 * renders it, which interaction category it belongs to and its display label.
 */
const SOURCE_CONFIG = {
  favoritelist: {
    category: SOURCE_CATEGORY.INSTRUMENT,
    component: FavoriteListSelection,
    label: 'Favoritenlisten',
  },
  musterdepot: {
    category: SOURCE_CATEGORY.PORTFOLIO,
    component: MusterDepot,
    label: 'Musterdepots',
  },
  modellportfolio: {
    category: SOURCE_CATEGORY.PORTFOLIO,
    component: ModelPortfolioSelection,
    label: 'Modellportfolios',
  },
  private_investment: {
    category: SOURCE_CATEGORY.PORTFOLIO,
    component: InvestmentStrategySelection,
    label: 'Vermögensverwaltung',
  },
  customer_portfolio: {
    category: SOURCE_CATEGORY.SELF_MANAGED,
    component: CustomerDepotSelection,
    label: 'Kundendepot',
  },
};

/**
 * Entry point for selecting products from a source.
 *
 * Keeps a stable public API (`open`, `source`, `onClose`, `onSelectProducts`)
 * and delegates to the container that implements the interaction model for the
 * given source category.
 *
 * `onSelectProducts(selectedInstruments, selectedSources)` receives the picked
 * instruments and an array of whole-source items (empty when none). It must
 * return a truthy value on success; a falsy value keeps the modal open.
 */
function ProductSourceSelectionModal({open, source, onClose, onSelectProducts}) {
  const config = SOURCE_CONFIG[source];

  if (!config) {
    return null;
  }

  const {category, component: SourceComponent, label} = config;

  const commonProps = {
    open,
    onClose,
    onSelectProducts,
    SourceComponent,
    backToSourceLabel: `Hinzufügen und zurück zu ${label}`,
  };

  switch (category) {
    case SOURCE_CATEGORY.INSTRUMENT:
      return <InstrumentSelectionFlow {...commonProps} />;
    case SOURCE_CATEGORY.PORTFOLIO:
      return <PortfolioSelectionFlow {...commonProps} />;
    case SOURCE_CATEGORY.SELF_MANAGED:
      return <SelfManagedSelectionFlow {...commonProps} />;
    default:
      return null;
  }
}

ProductSourceSelectionModal.propTypes = {
  open: PropTypes.bool,
  source: PropTypes.oneOf(Object.keys(SOURCE_CONFIG)),
  onClose: PropTypes.func.isRequired,
  onSelectProducts: PropTypes.func,
};

export default ProductSourceSelectionModal;
